var map = {
	"./AI.jpg": 9193,
	"./Contact.jpg": 8207,
	"./Cosmosimg.jpg": 7774,
	"./Cosmosimg2.jpg": 1638,
	"./Cover-Shopee.jpg": 3983,
	"./CoverSmarthis.jpg": 8599,
	"./IdCosmos.jpg": 208,
	"./IdPet.jpg": 5505,
	"./LandingCosmos.jpg": 5938,
	"./ScreenCosmos1.jpg": 7806,
	"./ScreenCosmos2.jpg": 1513,
	"./ScreenCosmos3.jpg": 6140,
	"./UiKitCosmos.jpg": 6665,
	"./Wireframesmedi.jpg": 9325,
	"./abtest.jpg": 6698,
	"./anna.jpg": 1337,
	"./cohabit-img.jpg": 6009,
	"./cover-cosmos.jpg": 4237,
	"./cover-medilinker.jpg": 859,
	"./dispcohabit.jpg": 6772,
	"./dispsmarthis.jpg": 5686,
	"./expandedmedi.jpg": 9415,
	"./id-landing.jpg": 9078,
	"./id-medilinker.jpg": 6565,
	"./idcohabit.jpg": 98,
	"./idsmarthis.jpg": 8501,
	"./landing-page.jpg": 8292,
	"./landing-page2.jpg": 1780,
	"./landing-page3.jpg": 305,
	"./medi-responsive.jpg": 513,
	"./medifinal.jpg": 1058,
	"./medilinker-img1.jpg": 2890,
	"./medilinker-img2.jpg": 9141,
	"./motion.jpg": 5117,
	"./profile.jpg": 5376,
	"./roomate.jpg": 4340,
	"./roomate2.jpg": 8692,
	"./smarthisimg1.jpg": 5456,
	"./smarthisimg2.jpg": 3455,
	"./smarthisimg3.jpg": 1746,
	"./smarthisimg4.jpg": 6353,
	"./thumb-cosmos.jpg": 5694
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1913;